import { levelAnchorsFor } from '@otryad/shared';

import { useHaptic } from '@/app/TmaProvider';
import { cn } from '@/lib/cn';
import { texts } from '@/lib/texts';

export interface LevelPickerProps {
  /** Код активности — подбирает текстовые якоря `LEVEL_ANCHORS` */
  activityCode: string;
  value: number | null;
  onChange: (level: number) => void;
}

const LEVELS = [1, 2, 3, 4, 5] as const;

/** Уровень 1–5 с текстовыми якорями (BLUEPRINT 2.2.4): честная самооценка вместо «средний». */
export function LevelPicker({ activityCode, value, onChange }: LevelPickerProps) {
  const anchors = levelAnchorsFor(activityCode);
  const haptic = useHaptic();
  return (
    <div className="flex flex-col gap-2" role="radiogroup" aria-label={texts.levels.group}>
      {LEVELS.map((level) => {
        const selected = value === level;
        return (
          <button
            key={level}
            type="button"
            role="radio"
            aria-checked={selected}
            // Раунд 4, N8: имя читалось склейкой «1НовичокИграл в школе» — теперь словами
            aria-label={`${texts.levels.label[level]}. ${anchors[level] ?? ''}`.trim()}
            onClick={() => {
              haptic.selection();
              onChange(level);
            }}
            className={cn(
              'rounded-control pressable flex w-full items-center gap-3 border px-3 py-2.5 text-left',
              selected
                ? 'border-accent bg-accent/15'
                : 'border-border bg-surface active:bg-surface-2',
            )}
          >
            <span
              className={cn(
                'num inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-base font-bold',
                selected ? 'bg-accent text-accent-fg' : 'bg-surface-2 text-fg',
              )}
            >
              {level}
            </span>
            <span className="min-w-0">
              <span className={cn('block text-sm font-semibold', selected && 'text-accent')}>
                {texts.levels.label[level]}
              </span>
              <span className="text-muted block text-sm leading-snug">{anchors[level]}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
